import { useAuthStore } from './store'
import { redirectToAuth } from './utils'

export function useAuth() {
  const { user, logout } = useAuthStore()

  return { user, logout, redirectToAuth }
}